export const keycloakUrlMap = {
  dev: 'https://sso-develop.tech.glide.io/auth',
  valid: 'https://sso-valid.tech.glide.io/auth',
  staging: 'https://sso-staging.tech.glide.io/auth',
  prod: 'https://sso.tech.glide.io/auth'
};
